import React, { useState, useEffect } from "react";
import styles from "./MonthYearFilter.module.scss";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import moment from "moment/moment";

function MonthYearFilter({
  isMonthly,
  isYearly,
  selectedMonthYear,
  setMonthlyDates,
  setSelectedMonthYear,
  setSelectedYear,
  selectedYear,
}) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const generateMonthYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const monthYearOptions = [];
    for (let year = currentYear; year >= 2010; year--) {
      const startMonth = year === currentYear ? currentMonth : 11;
      const endMonth = year === 2010 ? currentMonth : -1;
      for (let month = startMonth; month > endMonth; month--) {
        const monthYear = `${months[month]} ${year.toString().slice(2)}`;
        monthYearOptions.push({ label: monthYear, month, year });
      }
    }
    return monthYearOptions;
  };

  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let year = currentYear; year >= 2010; year--) {
      const nextYear = year+1;
      const yearRange = `${year}-${nextYear.toString().slice(2)}`;
      yearOptions.push({ label: yearRange, year });
    }
    return yearOptions;
  };

  const handleSelectChange = (event) => {
    setSelectedMonthYear(event.target.value);
    const { month, year } = JSON.parse(event.target.value);
    const startUTC = moment.utc(new Date(year, month, 2)).format("YYYY-MM-DD");
    const endUTC = moment
      .utc(new Date(year, month + 1, 1))
      .format("YYYY-MM-DD");
    setMonthlyDates({ start_date: startUTC, end_date: endUTC });
  };

  const handleSelectChangeYear = (event) => {
    setSelectedYear(event.target.value);
    const selectedYearValue = JSON.parse(event.target.value);
    const startUTC = moment
      .utc(new Date(selectedYearValue.year, 3, 2))
      .format("YYYY-MM-DD");
    const endUTC = moment
      .utc(new Date(selectedYearValue.year+1, 3, 1))
      .format("YYYY-MM-DD");
    setMonthlyDates({ start_date: startUTC, end_date: endUTC });
  };

  return (
    <div className={styles.monthYearFilter}>
      {isMonthly && (
        <div className={styles.selectWrapper}>
          <select
            className={styles.monthYearFilterSelect}
            value={selectedMonthYear}
            onChange={handleSelectChange}
          >
            {generateMonthYearOptions().map((option, index) => (
              <option
                className={styles.monthYearFilterSelectOptions}
                key={index}
                value={JSON.stringify(option)}
              >
                {option.label}
              </option>
            ))}
          </select>
          <ArrowDropDownIcon className={styles.customIcon} />
        </div>
      )}
      {isYearly && (
        <div className={styles.selectWrapper}>
          <select
            className={styles.monthYearFilterSelect}
            value={selectedYear}
            onChange={handleSelectChangeYear}
          >
            {generateYearOptions().map((option, index) => (
              <option
                className={styles.monthYearFilterSelectOptions}
                key={index}
                value={JSON.stringify(option)}
              >
                {option.label}
              </option>
            ))}
          </select>
          <ArrowDropDownIcon className={styles.customIcon} />
        </div>
      )}
    </div>
  );
}

export default MonthYearFilter;
